import {
  BaseButton,
  Sidebar,
  SelectMulti,
} from "@velocity-ehs/component-library";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useInfiniteGetUsers } from "../../../../hooks/useInfiniteGetUsers";
import { useInfiniteGetUsersAssignedToRole } from "../../../../hooks/useInfiniteGetUsersAssignedToRole";
import { useParams } from "react-router-dom";

interface Props {
  showSlider: boolean;
  closeSliderCallback?: () => void;
  assignRoleCallback?: (values: any) => void;
}

const LocationRoleAssignSlider: React.FC<Props> = ({
  showSlider,
  closeSliderCallback,
  assignRoleCallback,
}) => {
  const { t } = useTranslation();

  const formMethods = useForm<{ users: object[] }>({
    mode: "onBlur",
  });

  const urlSearchParams = new URLSearchParams(location.search);
  const locationID = urlSearchParams.get("locationID");
  const { id } = useParams() as { id: string };

  const { users, refetch, isFetching } = useInfiniteGetUsers();

  const { usersAssignedToRole, refetch: refetchRoles } =
    useInfiniteGetUsersAssignedToRole(id, locationID);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = formMethods;

  const onSubmit = async (data: { users: object[] }) => {
    await assignRoleCallback(data);
    refetch();
    refetchRoles();
    onClose();
  };

  const disableAssignedUsers = (infiniteUsers: any[]) => {
    const assignedUsersList = usersAssignedToRole.map((assignedUser) => {
      return assignedUser.userID;
    });

    return infiniteUsers.map((user: { id: string }) => {
      if (assignedUsersList.includes(user.id)) {
        return {
          ...user,
          disabled: true,
        };
      }
      return user;
    });
  };

  const onClose = () => {
    reset();
    closeSliderCallback();
  };

  const footerButtons = () => {
    return (
      <>
        <BaseButton
          type="submit"
          form="usersAssignRoleForm"
          loading={isSubmitting}
          label={t("universal_Save")}
        />
        <BaseButton
          type="button"
          label={t("universal_Cancel")}
          className="p-button-text"
          onClick={onClose}
        />
      </>
    );
  };

  return (
    <Sidebar
      header={t("user_roles_assign_users_slider_title")}
      visible={showSlider}
      onHide={onClose}
      footer={footerButtons()}
    >
      <form id="usersAssignRoleForm" onSubmit={handleSubmit(onSubmit)}>
        <SelectMulti
          errorMessage={errors.users?.message}
          options={disableAssignedUsers(users)}
          optionLabel="userDemographic.displayName"
          control={control}
          required
          name="users"
          label={t("universal_Users")}
          isLoading={isFetching}
        />
      </form>
    </Sidebar>
  );
};

export { LocationRoleAssignSlider };
